export function useCurrentModulePermission(permissionsDictionary = {}, code = '') {
  return permissionsDictionary ? permissionsDictionary[code] : [];
}
